import { getAuthenticationUrl } from './userAuthService';

const authenticationUrlBuilder = {
  build: (redirect = window.location.origin) => {
    const state = btoa(redirect);
    return getAuthenticationUrl(
      encodeURIComponent(`${window.location.origin}/access`),
      state
    );
  },
};

export default authenticationUrlBuilder;
